import { get, post, put } from './apiUtils';

export interface RenameTickerRequest {
    oldTicker: string;
    newTicker: string;
}

export interface RenameTickerResponse {
    oldTicker: string;
    newTicker: string;
    accountsUpdated: number;
    snapshotsHoldingsUpdated: number;
    snapshotsTickerValuesUpdated: number;
    strategiesUpdated: number;
    simulationsUpdated: number;
    totalUpdated: number;
    success: boolean;
    message: string;
}

export interface ApplicationUser {
    id: string;
    xRefCode: string;
    name: string;
    fullName: string;
    email: string;
    picture: string;
    isAdmin: boolean;
    displayCurrency: string;
    privacyMode: boolean;
}

export const getApplicationUser = async (): Promise<ApplicationUser> => {
    return get('/api/users/me');
};

export const updateApplicationUserDisplayCurrency = async (displayCurrency: string): Promise<ApplicationUser> => {
    return put('/api/users/me/display-currency', { displayCurrency });
};

export const updateApplicationUserPrivacyMode = async (privacyMode: boolean): Promise<ApplicationUser> => {
    return put('/api/users/me/privacy-mode', { privacyMode });
};

export const renameTicker = async (request: RenameTickerRequest): Promise<RenameTickerResponse> => {
    return post('/api/admin/tickers/rename', request);
};
